import { getEnvironmentInfo } from '~/utils/get-environment-info';
import { goToFullWebviewOnApp, goToWebviewOnApp } from '~/services/app-interface';

/**
 * 웹뷰/웹 환경에 따라 이동하는 함수
 *
 * @description push, replace를 할 경우 서버 컴포넌트에서는 바뀐 상태를 캐치할 수 없음
 */
export const navigateByEnvironment = (
  path: string,
  option: 'push' | 'replace' | 'webview' | 'full-webview' | 'open',
) => {
  if (!globalThis.window) return;

  const { isWebview } = getEnvironmentInfo();

  switch (option) {
    case 'push':
      globalThis.window.history.pushState({}, '', path);
      break;
    case 'replace':
      globalThis.window.history.replaceState({}, '', path);
      break;
    case 'webview':
      if (isWebview) {
        goToWebviewOnApp({ url: `${globalThis.window.location.origin}${path}` }).go();
        break;
      }

      globalThis.window.open(path, '_blank');
      break;
    case 'full-webview':
    case 'open':
      if (isWebview) {
        goToFullWebviewOnApp({ url: `${globalThis.window.location.origin}${path}` }).go();
        break;
      }

      globalThis.window.open(path, '_blank');
      break;
    default:
      throw new Error('잘못된 옵션 입력');
  }
};
